import { Link, WithRecord } from "react-admin";
import { getCurrentEnv } from "../../ra-lb-tools/utils/tools";
import { Launch } from "@mui/icons-material";
import get from "lodash/get";

const stripeUri = "https://dashboard.stripe.com/";

const pathMapping = {
  prod: "products",
  price: "prices",
  sub: "subscriptions",
  cus: "customers",
  in: "invoices",
};

const getEnvPath = () =>
  ["LOCAL", "DEV"].includes(getCurrentEnv()) ? "test/" : "";

export const StripeLink = ({ entity, id = "processorId", ...props }) => {
  return (
    <WithRecord
      render={(record) => {
        const record_id = get(record, id);
        const sufix = record_id?.split("_")[0];
        entity = entity || pathMapping[sufix];

        if (!entity) return null;

        return (
          <Link
            target="_blank"
            to={`${stripeUri}${getEnvPath()}${entity}/${record_id}`}
            title={`Check ${entity} on Stripe`}
            {...props}
          >
            <Launch />
          </Link>
        );
      }}
    />
  );
};
